import { Form, Input } from 'antd';
import React, { ChangeEvent, FC } from 'react';
import { TSettingsParams } from 'shared/types/admins.types';

type UpdatedFieldProps = {
  data?: TSettingsParams;
  field: string;
  setData: (val: TSettingsParams) => void;
  isUpdating: boolean;
};

const UpdatedField: FC<UpdatedFieldProps> = ({ data, setData, isUpdating, field }) => {
  const onChange = (val: string) => {
    if (data) {
      setData({ ...data, [field]: val });
    }
  };

  return (
    <>
      {isUpdating && field === 'value' ? (
        <Input
          defaultValue={data?.[field]}
          onChange={(ev: ChangeEvent) => onChange((ev.target as HTMLInputElement).value)}
          type="number"
        ></Input>
      ) : (
        <span>{data?.[field]}</span>
      )}
    </>
  );
};

export default UpdatedField;
